import ClickableHelpText from '../HelpText/ClickableHelpText';

type RadioSelectionProps = {
  show: boolean;
  selectionName: string;
  error?: string;
  fontDisabledClass: string;
  children: JSX.Element[];
  helpText?: string;
};

const RadioSelection = ({
  show,
  selectionName,
  error,
  fontDisabledClass,
  children,
  helpText
}: RadioSelectionProps): JSX.Element => {
  if (!show) return <></>;

  return (
    <>
      <div
        className={`control-label m05-bottom ${fontDisabledClass} help-text`}>
        {selectionName}
        {helpText && <ClickableHelpText helpText={helpText} />}
      </div>
      <div className='control'>
        {children}
        {error && <div className='error-style'>{error}</div>}
      </div>
    </>
  );
};

export default RadioSelection;
